import React from 'react';
import { Target, DollarSign, Layers } from 'lucide-react';
import { ProjectionData } from '../data/mockData';
interface PerformanceProjectionsProps {
  projections: ProjectionData;
}
export function PerformanceProjections({
  projections
}: PerformanceProjectionsProps) {
  const lockProgress = Math.min(100, projections.lockActual / projections.lockTarget * 100);
  const commissionProgress = Math.min(100, projections.commissionActual / projections.commissionTarget * 100);
  const formatCurrency = (val: number) => new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0
  }).format(val);
  return <section className="bg-slate-800/60 border border-slate-700/50 rounded-xl p-6 h-full flex flex-col" data-id="element-113">
      <h2 className="text-lg font-semibold text-white mb-6 flex items-center gap-2" data-id="element-114">
        <span className="w-1.5 h-5 bg-purple-500 rounded-full" data-id="element-115"></span>
        Forecast & Projections
      </h2>

      <div className="flex flex-col gap-6 flex-1 justify-center" data-id="element-116">
        {/* Lock Projection */}
        <div data-id="element-117">
          <div className="flex justify-between items-end mb-2" data-id="element-118">
            <div className="flex items-center gap-2 text-slate-300 font-medium" data-id="element-119">
              <Target className="w-4 h-4 text-purple-400" data-id="element-120" />
              Lock Target
            </div>
            <div className="text-right" data-id="element-121">
              <span className="text-xl font-bold text-white" data-id="element-122">
                {projections.lockActual}
              </span>
              <span className="text-slate-400 text-sm" data-id="element-123">
                {' '}
                / {projections.lockTarget}
              </span>
            </div>
          </div>
          <div className="h-2.5 w-full bg-slate-900 rounded-full overflow-hidden border border-slate-700/50" data-id="element-124">
            <div className="h-full bg-gradient-to-r from-purple-600 to-purple-400 rounded-full relative" style={{
            width: `${lockProgress}%`
          }} data-id="element-125">
              <div className="absolute top-0 right-0 bottom-0 w-4 bg-white/20 animate-[pulse_2s_ease-in-out_infinite]" data-id="element-126"></div>
            </div>
          </div>
        </div>

        {/* Commission Projection */}
        <div data-id="element-127">
          <div className="flex justify-between items-end mb-2" data-id="element-128">
            <div className="flex items-center gap-2 text-slate-300 font-medium" data-id="element-129">
              <DollarSign className="w-4 h-4 text-emerald-400" data-id="element-130" />
              Commission
            </div>
            <div className="text-right" data-id="element-131">
              <span className="text-xl font-bold text-white" data-id="element-132">
                {formatCurrency(projections.commissionActual)}
              </span>
              <span className="text-slate-400 text-sm" data-id="element-133">
                {' '}
                / {formatCurrency(projections.commissionTarget)}
              </span>
            </div>
          </div>
          <div className="h-2.5 w-full bg-slate-900 rounded-full overflow-hidden border border-slate-700/50" data-id="element-134">
            <div className="h-full bg-gradient-to-r from-emerald-600 to-emerald-400 rounded-full relative" style={{
            width: `${commissionProgress}%`
          }} data-id="element-135">
              <div className="absolute top-0 right-0 bottom-0 w-4 bg-white/20 animate-[pulse_2s_ease-in-out_infinite]" data-id="element-136"></div>
            </div>
          </div>
        </div>

        {/* Pipeline Coverage */}
        <div className="bg-slate-900/50 rounded-lg p-4 border border-slate-700/50 flex items-center justify-between mt-2" data-id="element-137">
          <div className="flex items-center gap-3" data-id="element-138">
            <div className="p-2 bg-blue-500/20 rounded-lg" data-id="element-139">
              <Layers className="w-5 h-5 text-blue-400" data-id="element-140" />
            </div>
            <div data-id="element-141">
              <div className="text-sm text-slate-400 font-medium" data-id="element-142">
                Pipeline Coverage
              </div>
              <div className="text-xs text-slate-500" data-id="element-143">Target: 2.0x</div>
            </div>
          </div>
          <div className="text-right" data-id="element-144">
            <div className={`text-2xl font-bold ${projections.pipelineCoverage >= 2.0 ? 'text-emerald-400' : 'text-amber-400'}`} data-id="element-145">
              {projections.pipelineCoverage.toFixed(1)}x
            </div>
          </div>
        </div>
      </div>
    </section>;
}